module.exports = __webpack_public_path__ + "h5/img/jifen.f6fe318a.png";